import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  Grid,
  Stack,
  IconButton,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import WaitingLoder from "../../Loader/component";

// Assets
import bpImage from "../../assets/bpImage.png";
import paper from "../../assets/paper.png";
import calculater from "../../assets/calculater.png";
import watch from "../../assets/watch.png";
import inputMailIcon from "../../assets/inputMailIcon.png";
import mail from "../../assets/mail.png";
import backArrow from "../../assets/backArrow.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// Common Header (replace with your actual header component)

const MyHeader = () => {
  const navigate=useNavigate()
   const handleBack=()=>{
    navigate('/profile')
   }
  return (
    <Box display="flex" alignItems="center" p={2} sx={{ background: "#fae14b" ,position: "fixed",width:"100%",zIndex: "999"}}>
      <Box display={"flex"} width={"100%"} alignItems={"center"}     justifyContent="space-between">
      <Box display={"flex"}>
      <IconButton onClick={handleBack}>
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
        Business Payment
      </Typography>
      </Box>
  
      </Box>
    </Box>
  );
};

const BusinessPayment = (props) => {
  const [otpInputs, setOtpInputs] = useState(["", "", "", "", "", ""]);
  const otpRefs = useRef([]);

  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otpInputs];
      newOtp[index] = value;
      setOtpInputs(newOtp);
      props.handleChangeOtp(newOtp.join(""));
      if (value && index < 5) otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpInputs[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
  };

  const AddAccount = () => props.setPageCounter(0);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "rgba(240,248,250,0.4)" }}>
      {props.loader && <WaitingLoder />}

      {/* ✅ Common Header */}
            <MyHeader
              title={"Link Business Account"
              }
              subtitle={""}
              route="/profile"
            />
  

      {/* STEP 0: Intro */}
      {props.pageCounter === 0 && (
        <Stack p={2} alignItems="center" textAlign="center" spacing={4} >
          <Box mt={4} style={{marginTop: "85px"}}>
            <img
              src={bpImage}
              alt="Business Payment"
              style={{ width: "45vw", maxWidth: 200,"mix-blend-mode":"darken" }}
            />
          </Box>

          <Typography fontSize={20} fontWeight={700} color="#384F6F">
            Enjoy Daalchini at Work
          </Typography>
          <Typography fontSize={13} color="rgba(113,129,152,1)">
            Daalchini partners with businesses to pay for food at work
          </Typography>

          <Stack spacing={2} mt={3}>
            {[
              { icon: paper, text: "Bills businesses for using Daalchini at work" },
              { icon: calculater, text: "Helps maintain business expense account" },
              { icon: watch, text: "Saves employee time" },
            ].map((item, i) => (
              <Stack key={i} direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    background: "#80808029",
                    borderRadius: "50%",
                    width: 48,
                    height: 48,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={item.icon} alt="icon" width="22px" />
                </Box>
                <Typography fontSize={14} color="#384F6F" textAlign="left">
                  {item.text}
                </Typography>
              </Stack>
            ))}
          </Stack>

          <Box width="100%" mt={5}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                background: "rgba(0,177,119,1)",
                borderRadius: "12px",
                height: 48,
                fontWeight: 600,
                color: "white",
              }}
              onClick={() => props.setPageCounter(1)}
            >
              Link Business Expense Account
            </Button>
            <Typography color="#94A3B8" mt={2}>
              Or
            </Typography>
            <a
              href="https://www.daalchini.co.in/"
              style={{
                color: "rgba(100,116,139,1)",
                textDecoration: "none",
                fontSize: 14,
                textDecoration: "underline",
              }}

            >
              Avail this service for your Business
            </a>
          </Box>
        </Stack>
      )}

      {/* STEP 1: Email Input */}
      {props.emailFlag && props.pageCounter === 1 && (
        <Box p={3} pt={8} textAlign="center" style={{paddingTop: "185px"}}>
         <div style={{display:"flex",    justifyContent:"center"}}><img src={mail} alt="Mail" width="60px" /></div> 
          <Typography fontWeight={700} fontSize={20} color="#384F6F" mt={2}>
            Enter your business email
          </Typography>

          <TextField
            fullWidth
            variant="outlined"
            value={props.email}
            onChange={props.handleChangeEmail}
            placeholder="Enter your company email ID"
            sx={{ mt: 5, bgcolor: "white", borderRadius: "12px" }}
            InputProps={{
              startAdornment: (
                <img
                  src={inputMailIcon}
                  alt="email"
                  style={{ width: 20, marginRight: 8, "mix-blend-mode":"darken" }}
                  
                />
              ),
            }}
          />

          <Typography variant="body2" color="text.secondary" mt={5}>
            By linking your account, you agree to our Terms & Conditions.
          </Typography>

          <Button
            onClick={props.handleSubmit}
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              height: 48,
              fontWeight: 600,
              borderRadius: "13px",
              backgroundColor:
                props.email.length > 5 ? "rgba(0,177,119,1)" : "#82938d",
                ":hover":{
                  background:"rgba(0,177,119,1)"

                }
            }}
            disabled={props.email.length <= 5}
          >
            LINK ACCOUNT
          </Button>
        </Box>
      )}

      {/* STEP 2: OTP Verification */}
      {props.pageCounter === 2 && (
        <Box p={3} pt={"50vw"} textAlign="center">
          <div style={{display:"flex",justifyContent:"center"}}>
          <img src={mail} alt="Mail" width="80px"  />
          </div>
          <Typography fontWeight={700} fontSize={20} color="#384F6F" mt={2}>
            Verify your Email
          </Typography>
          <Typography fontSize={14} color="#64748B" mt={1}>
            Enter 6-digit OTP sent to your email
          </Typography>

          <Grid container justifyContent="center" spacing={1} mt={3}>
            {otpInputs.map((val, i) => (
              <Grid item key={i}>
                <TextField
                  inputRef={(el) => (otpRefs.current[i] = el)}
                  value={val}
                  onChange={(e) => handleOtpChange(i, e.target.value)}
                  onKeyDown={(e) => handleOtpKeyDown(i, e)}
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      fontSize: "18px",
                      width: "16px",
                      height: "16px",
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>

          <Box mt={4}>
            <Typography>
              Didn’t receive code?{" "}
              {props.remainingTime > 0 ? (
                <span>{props.remainingTime}s</span>
              ) : (
                <span
                  onClick={props.handleSendOTP}
                  style={{ color: "rgb(0, 177, 119)", cursor: "pointer" }}
                >
                  Resend
                </span>
              )}
            </Typography>
          </Box>

          <Button
            onClick={props.submitOtp}
            fullWidth
            variant="contained"
            sx={{
              mt: 5,
              height: 48,
              fontWeight: 600,
              borderRadius: "13px",
              backgroundColor:
                props.otpcode.length === 6 ? "rgba(0,177,119,1)" : "#BCBDBD",
                 ":hover":{
                  background:"rgba(0,177,119,1)"

                }
            }}
            disabled={props.otpcode.length !== 6}
          >
            Verify Account
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default BusinessPayment;
